import { Preferences } from '@capacitor/preferences';
import { isNative } from './env';

// Unified key/value store. On native uses Capacitor Preferences (persists across
// app updates, NOT encrypted). On web falls back to localStorage so the same
// API works in `npm start`.

export async function storageGet(key) {
    if (isNative) {
        const { value } = await Preferences.get({ key });
        return value ?? null;
    }
    return localStorage.getItem(key);
}

export async function storageSet(key, value) {
    if (value === null || value === undefined) {
        return storageRemove(key);
    }
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
    if (isNative) {
        await Preferences.set({ key, value: stringValue });
        return;
    }
    localStorage.setItem(key, stringValue);
}

export async function storageRemove(key) {
    if (isNative) {
        await Preferences.remove({ key });
        return;
    }
    localStorage.removeItem(key);
}

export async function storageClear() {
    if (isNative) {
        await Preferences.clear();
        return;
    }
    localStorage.clear();
}

// One-time migration of legacy localStorage keys into Capacitor Preferences.
// Runs at app boot before render; idempotent via a flag.
const MIGRATION_FLAG = 'storage:migrated:v1';
const LEGACY_KEYS = ['language', 'selectedCountry', 'selectedCharger'];

export async function bootstrapMigration() {
    if (!isNative) return;
    try {
        const flag = await storageGet(MIGRATION_FLAG);
        if (flag === '1') return;

        for (const key of LEGACY_KEYS) {
            const legacy = localStorage.getItem(key);
            if (legacy != null && legacy !== '') {
                await Preferences.set({ key, value: legacy });
            }
        }
        await Preferences.set({ key: MIGRATION_FLAG, value: '1' });
    } catch (err) {
        console.warn('storage migration skipped:', err);
    }
}
